import { differenceInDays } from 'date-fns/fp'

export const isMoreThan7DaysAway = (endDate: Date): boolean => {
  const currentDate = new Date()
  const daysAway = differenceInDays(currentDate, endDate)

  return daysAway >= 7
}
